import React, { useState } from "react";
import {
  Bars3Icon,
  BanknotesIcon,
  IdentificationIcon,
  ChartBarIcon,
  ArrowRightOnRectangleIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import FinanceDashboard from "./FinansAgro/FinanceDashboard";
import WithdrawalsReview from "./FinansAgro/WithdrawalsReview";
import KycReview from "./FinansAgro/KycReview";
import ThemeSwitch from "./ThemeSwitch";

const NAV = [
  { id: "dashboard", name: "Dashboard", icon: ChartBarIcon },
  { id: "withdrawals", name: "Withdrawals", icon: BanknotesIcon },
  { id: "kyc", name: "KYC", icon: IdentificationIcon },
];

const FinansAgroDashboard = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("google_id_token");
    window.location.href = "/";
  };

  const renderContent = () => {
    switch (activeTab) {
      case "withdrawals":
        return <WithdrawalsReview />;
      case "kyc":
        return <KycReview />;
      case "dashboard":
      default:
        return <FinanceDashboard />;
    }
  };

  return (
    <div className="flex min-h-screen bg-bg-base">
      {/* Sidebar */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-72 dark-sidebar transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:relative lg:flex-shrink-0 ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-6 border-b border-gray-700">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-accent-grad rounded-xl flex items-center justify-center shadow-lg">
                <BanknotesIcon className="w-7 h-7 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Finance</h1>
                <p className="text-sm text-text-secondary">FinansAgro panel</p>
              </div>
            </div>
            <button
              onClick={() => setSidebarOpen(false)}
              className="lg:hidden p-2 rounded-lg text-text-secondary hover:text-white hover:bg-bg-primary"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>

          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {NAV.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setActiveTab(item.id);
                    setSidebarOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    isActive
                      ? "bg-accent-grad text-white shadow-lg"
                      : "text-text-secondary hover:bg-bg-primary hover:text-white"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="text-sm font-medium">{item.name}</span>
                </button>
              );
            })}
          </nav>

          <div className="p-4 border-t border-gray-700 space-y-2">
            <div className="flex items-center justify-between px-2">
              <span className="text-xs text-text-secondary">Тема</span>
              <ThemeSwitch />
            </div>
            <button
              onClick={handleLogout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-text-secondary hover:bg-red-500/10 hover:text-red-400 transition-colors"
            >
              <ArrowRightOnRectangleIcon className="w-5 h-5" />
              <span className="text-sm font-medium">Шығу</span>
            </button>
          </div>
        </div>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Content */}
      <div className="flex-1 flex flex-col min-w-0">
        <header className="dark-card border-b border-gray-700 px-4 py-3 flex items-center justify-between lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg text-text-secondary hover:text-white hover:bg-bg-primary"
          >
            <Bars3Icon className="w-6 h-6" />
          </button>
          <h2 className="text-base font-semibold text-white">
            {NAV.find((n) => n.id === activeTab)?.name || "Finance"}
          </h2>
          <div className="w-10" />
        </header>

        <main className="flex-1 p-4 md:p-6 overflow-x-hidden">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default FinansAgroDashboard;
